<div id="acknowledgment" class="registration container">
  <form novalidate autocomplete="off">
    <h1>{{ 'copy.label.ACKNOWLEDGEMENT.confirmation' | copy | async }}</h1>
    <h3 class="georgia">{{ 'copy.label.ACKNOWLEDGEMENT.success' | copy | async }}</h3>
    <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor'" class="w-100 mb-3" [innerHTML]='"copy.html.mysacknote" | copy | async'></div>
    <p class="w-100" [innerHTML]='"copy.html.cancelNote"|copy|async'></p>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.LOGOUT.contact' | copy | async }}
        </div>
      </div>
      <div class="travelLinksPrimaryAndGuest">
        <article class="p-4">
          <!-- <app-contactus>{{'copy.label.ACKNOWLEDGEMENT.question' | copy | async }}</app-contactus> -->
          <a (click)="openContactModal()">{{'copy.label.ACKNOWLEDGEMENT.question'|copy|async}}</a>
        </article>
      </div>
    </section>

    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.ACKNOWLEDGEMENT.traveldesk' | copy | async }}
        </div>
      </div>
      <div class="travelLinksPrimaryAndGuest">
        <article class="p-4">
          <p *ngIf="phone0">
            {{"copy.label.CONTACTUS.phone"|copy |async}} {{'travelHQ800Num' | copy | async}}
          </p>
          <p *ngIf="phone1">
            {{"copy.label.CONTACTUS.phone"|copy|async}} {{'travelHQIntlNum' | copy | async}}
          </p>
          <p>{{"copy.label.CONTACTUS.email2"|copy|async}} <a
              href="mailto:{{'travelHQEmail' | copy | async}}">{{'travelHQEmail' | copy | async}}</a>
          </p>
          <p>{{"copy.label.CONTACTUS.hours"|copy|async}} {{'programSupportHours' | copy | async}}</p>
        </article>
      </div>
    </section>
  </form>
</div>
